import WPTextArea from "./WPTextArea";

export default WPTextArea;